export default __webpack_public_path__ + "static/media/blockparty-logo-light.eeed13b3.svg";